import { SharedLocationDisplayType, SharingType } from '@bringg/types';
import { SHARING_TYPES_WITH_DYNAMIC_DISPLAY_TYPE } from '../consts';

export function isScheduleShareType({
	sharedType,
	displayType
}: {
	sharedType: SharingType;
	displayType: SharedLocationDisplayType;
}): boolean {
	return (
		sharedType === SharingType.Schedule ||
		sharedType === SharingType.Reschedule ||
		(SHARING_TYPES_WITH_DYNAMIC_DISPLAY_TYPE.includes(sharedType) &&
			displayType === SharedLocationDisplayType.Schedule)
	);
}
